import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';

import { types as sdkTypes, createImageVariantConfig } from '../../util/sdkLoader';
import { findNextBoundary, getStartOf, monthIdString } from '../../util/dates';
import { storableError } from '../../util/errors';
import {
  captureChargeApi,
  createNonCardChargeApi,
  initiaterescheduleBookingApi,
  createCardRefundApi,
  createNonCardRefundApi,
  reverseCardChargeApi,
  sendWelcomeGuideMessageApi,
  transactionLineItems,
  retrieveRecipientApi,
  generatePaymentReceiptApi,
  sendTransactionMessageApi,
  submitReviewApi,
} from '../../util/api';
import * as log from '../../util/log';
import {
  updatedEntities,
  denormalisedEntities,
  denormalisedResponseEntities,
} from '../../util/data';
import {
  getEffectivePaymentMethod,
  isPayLaterTransaction,
  resolveLatestProcessName,
  getProcess,
} from '../../transactions/transaction';

import { addMarketplaceEntities, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser, fetchCurrentUserNotifications } from '../../ducks/user.duck';
import { transitions } from '../../transactions/transactionProcessBooking';
import {
  buildRefundObjFromCancelOrMeta,
  calculateCustomerRefund,
  calculateProviderRefund,
  getCancelEmailObject,
  getRecipientId,
  getSubMerchantIdFromUser,
  getWelcomeGuide,
  hasAcceptedReschedule,
} from '../../util/genericHelpers';
import { PAYMENT_METHODS, TRANSITIONS } from '../../util/enums';
import { shouldPersistWelcomeGuideMessage } from '../../util/welcomeGuideHelpers';
import {
  createPreBookingContactBlockError,
  shouldBlockPreBookingMessage,
} from '../../util/messageContentSafety';
import { completeCustomOfferPaymentIfNeeded } from '../../util/customOfferPaymentCompletion';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { clearData } from '../CheckoutPage/CheckoutPageSessionHelpers';

const { UUID } = sdkTypes;
const STORAGE_KEY = 'CheckoutPage';

const MESSAGES_PAGE_SIZE = 100;
// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/TransactionPage/SET_INITIAL_VALUES';

export const FETCH_TRANSACTION_REQUEST = 'app/TransactionPage/FETCH_TRANSACTION_REQUEST';
export const FETCH_TRANSACTION_SUCCESS = 'app/TransactionPage/FETCH_TRANSACTION_SUCCESS';
export const FETCH_TRANSACTION_ERROR = 'app/TransactionPage/FETCH_TRANSACTION_ERROR';

export const FETCH_TRANSITIONS_REQUEST = 'app/TransactionPage/FETCH_TRANSITIONS_REQUEST';
export const FETCH_TRANSITIONS_SUCCESS = 'app/TransactionPage/FETCH_TRANSITIONS_SUCCESS';
export const FETCH_TRANSITIONS_ERROR = 'app/TransactionPage/FETCH_TRANSITIONS_ERROR';

export const TRANSITION_REQUEST = 'app/TransactionPage/MARK_RECEIVED_REQUEST';
export const TRANSITION_SUCCESS = 'app/TransactionPage/TRANSITION_SUCCESS';
export const TRANSITION_ERROR = 'app/TransactionPage/TRANSITION_ERROR';

export const FETCH_MESSAGES_REQUEST = 'app/TransactionPage/FETCH_MESSAGES_REQUEST';
export const FETCH_MESSAGES_SUCCESS = 'app/TransactionPage/FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_ERROR = 'app/TransactionPage/FETCH_MESSAGES_ERROR';

export const SEND_MESSAGE_REQUEST = 'app/TransactionPage/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'app/TransactionPage/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'app/TransactionPage/SEND_MESSAGE_ERROR';

export const SEND_REVIEW_REQUEST = 'app/TransactionPage/SEND_REVIEW_REQUEST';
export const SEND_REVIEW_SUCCESS = 'app/TransactionPage/SEND_REVIEW_SUCCESS';
export const SEND_REVIEW_ERROR = 'app/TransactionPage/SEND_REVIEW_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/TransactionPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/TransactionPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/TransactionPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/TransactionPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/TransactionPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/TransactionPage/FETCH_LINE_ITEMS_ERROR';

export const UPDATE_BOOKING_REQUEST = 'app/TransactionPage/UPDATE_BOOKING_REQUEST';
export const UPDATE_BOOKING_SUCCESS = 'app/TransactionPage/UPDATE_BOOKING_SUCCESS';
export const UPDATE_BOOKING_ERROR = 'app/TransactionPage/UPDATE_BOOKING_ERROR';

export const CREATE_CHARGE_REQUEST = 'app/TransactionPage/CREATE_CHARGE_REQUEST';
export const CREATE_CHARGE_SUCCESS = 'app/TransactionPage/CREATE_CHARGE_SUCCESS';
export const CREATE_CHARGE_ERROR = 'app/TransactionPage/CREATE_CHARGE_ERROR';

export const CONFIRM_PAYMENT_REQUEST = 'app/TransactionPage/CONFIRM_PAYMENT_REQUEST';
export const CONFIRM_PAYMENT_SUCCESS = 'app/TransactionPage/CONFIRM_PAYMENT_SUCCESS';
export const CONFIRM_PAYMENT_ERROR = 'app/TransactionPage/CONFIRM_PAYMENT_ERROR';

export const SET_OMISE_RECIPIENT_DATA_REQUEST =
  'app/TransactionPage/SET_OMISE_RECIPIENT_DATA_REQUEST';
export const SET_OMISE_RECIPIENT_DATA_SUCCESS =
  'app/TransactionPage/SET_OMISE_RECIPIENT_DATA_SUCCESS';
export const SET_OMISE_RECIPIENT_DATA_ERROR = 'app/TransactionPage/SET_OMISE_RECIPIENT_DATA_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchTransactionInProgress: false,
  fetchTransactionError: null,
  transactionRef: null,
  transitionInProgress: null,
  transitionError: null,
  fetchMessagesInProgress: false,
  fetchMessagesError: null,
  totalMessages: 0,
  totalMessagePages: 0,
  oldestMessagePageFetched: 0,
  messages: [],
  initialMessageFailedToTransaction: null,
  savePaymentMethodFailed: false,
  sendMessageInProgress: false,
  sendMessageError: null,
  sendReviewInProgress: false,
  sendReviewError: null,
  monthlyTimeSlots: {
    // '2022-03': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  fetchTransitionsInProgress: false,
  fetchTransitionsError: null,
  processTransitions: null,
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  updateBookingInProgress: false,
  updateBookingError: null,

  createChargeInProgress: false,
  createChargeError: null,
  chargeData: null,
  confirmPaymentError: null,

  omiseRecipientData: null,
  omiseRecipientDataInProgress: false, // keep original key
  omiseRecipientDataError: null,
};

// Merge entity arrays using ids, so that conflicting items in newer array (b) overwrite old values (a).
// const a = [{ id: { uuid: 1 } }, { id: { uuid: 3 } }];
// const b = [{ id: : { uuid: 2 } }, { id: : { uuid: 1 } }];
// mergeEntityArrays(a, b)
// => [{ id: { uuid: 3 } }, { id: : { uuid: 2 } }, { id: : { uuid: 1 } }]
const mergeEntityArrays = (a, b) => {
  return a.filter(aEntity => !b.find(bEntity => aEntity.id.uuid === bEntity.id.uuid)).concat(b);
};

export default function transactionPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SET_OMISE_RECIPIENT_DATA_REQUEST:
      return { ...state, omiseRecipientDataInProgress: true };
    case SET_OMISE_RECIPIENT_DATA_SUCCESS:
      return {
        ...state,
        omiseRecipientData: payload || null,
        omiseRecipientDataInProgress: false,
        omiseRecipientDataError: null,
      };
    case SET_OMISE_RECIPIENT_DATA_ERROR:
      return { ...state, omiseRecipientDataError: payload, omiseRecipientDataInProgress: false };

    case FETCH_TRANSACTION_REQUEST:
      return { ...state, fetchTransactionInProgress: true, fetchTransactionError: null };
    case FETCH_TRANSACTION_SUCCESS: {
      const transactionRef = { id: payload.data.data.id, type: 'transaction' };
      return { ...state, fetchTransactionInProgress: false, transactionRef };
    }
    case FETCH_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransactionInProgress: false, fetchTransactionError: payload };

    case FETCH_TRANSITIONS_REQUEST:
      return { ...state, fetchTransitionsInProgress: true, fetchTransitionsError: null };
    case FETCH_TRANSITIONS_SUCCESS:
      return { ...state, fetchTransitionsInProgress: false, processTransitions: payload };
    case FETCH_TRANSITIONS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransitionsInProgress: false, fetchTransitionsError: payload };

    case TRANSITION_REQUEST:
      return {
        ...state,
        transitionInProgress: payload,
        transitionError: null,
      };
    case TRANSITION_SUCCESS:
      return { ...state, transitionInProgress: null };
    case TRANSITION_ERROR:
      return {
        ...state,
        transitionInProgress: null,
        transitionError: payload,
      };

    case FETCH_MESSAGES_REQUEST:
      return { ...state, fetchMessagesInProgress: true, fetchMessagesError: null };
    case FETCH_MESSAGES_SUCCESS: {
      const oldestMessagePageFetched =
        state.oldestMessagePageFetched > payload.page
          ? state.oldestMessagePageFetched
          : payload.page;
      return {
        ...state,
        fetchMessagesInProgress: false,
        messages: mergeEntityArrays(state.messages, payload.messages),
        totalMessages: payload.totalItems,
        totalMessagePages: payload.totalPages,
        oldestMessagePageFetched,
      };
    }
    case FETCH_MESSAGES_ERROR:
      return { ...state, fetchMessagesInProgress: false, fetchMessagesError: payload };

    case SEND_MESSAGE_REQUEST:
      return {
        ...state,
        sendMessageInProgress: true,
        sendMessageError: null,
        initialMessageFailedToTransaction: null,
      };
    case SEND_MESSAGE_SUCCESS:
      return { ...state, sendMessageInProgress: false };
    case SEND_MESSAGE_ERROR:
      return { ...state, sendMessageInProgress: false, sendMessageError: payload };

    case SEND_REVIEW_REQUEST:
      return { ...state, sendReviewInProgress: true, sendReviewError: null };
    case SEND_REVIEW_SUCCESS:
      return { ...state, sendReviewInProgress: false };
    case SEND_REVIEW_ERROR:
      return { ...state, sendReviewInProgress: false, sendReviewError: payload };

    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }

    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case UPDATE_BOOKING_REQUEST:
      return { ...state, updateBookingInProgress: true, updateBookingError: null };
    case UPDATE_BOOKING_SUCCESS:
      return { ...state, updateBookingInProgress: false };
    case UPDATE_BOOKING_ERROR:
      return { ...state, updateBookingInProgress: false, updateBookingError: payload };

    case CREATE_CHARGE_REQUEST:
      return { ...state, createChargeInProgress: true, createChargeError: null };
    case CREATE_CHARGE_SUCCESS:
      return { ...state, createChargeInProgress: false, chargeData: action.payload };
    case CREATE_CHARGE_ERROR:
      return { ...state, createChargeInProgress: false, createChargeError: action.payload };

    case CONFIRM_PAYMENT_REQUEST:
      return { ...state, confirmPaymentError: null };
    case CONFIRM_PAYMENT_SUCCESS:
      return state;
    case CONFIRM_PAYMENT_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return { ...state, confirmPaymentError: payload };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const transitionInProgress = state => {
  return state.TransactionPage.transitionInProgress;
};

const selectRecipientId = state =>
  state?.user?.currentUser?.attributes?.profile?.publicData?.omiseRecipientId;

// ================ Action creators ================ //
export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const fetchTransactionRequest = () => ({ type: FETCH_TRANSACTION_REQUEST });
const fetchTransactionSuccess = response => ({
  type: FETCH_TRANSACTION_SUCCESS,
  payload: response,
});
const fetchTransactionError = e => ({ type: FETCH_TRANSACTION_ERROR, error: true, payload: e });

const fetchTransitionsRequest = () => ({ type: FETCH_TRANSITIONS_REQUEST });
const fetchTransitionsSuccess = response => ({
  type: FETCH_TRANSITIONS_SUCCESS,
  payload: response,
});
const fetchTransitionsError = e => ({ type: FETCH_TRANSITIONS_ERROR, error: true, payload: e });

const transitionRequest = transitionName => ({ type: TRANSITION_REQUEST, payload: transitionName });
const transitionSuccess = () => ({ type: TRANSITION_SUCCESS });
const transitionError = e => ({ type: TRANSITION_ERROR, error: true, payload: e });

const fetchMessagesRequest = () => ({ type: FETCH_MESSAGES_REQUEST });
const fetchMessagesSuccess = (messages, pagination) => ({
  type: FETCH_MESSAGES_SUCCESS,
  payload: { messages, ...pagination },
});
const fetchMessagesError = e => ({ type: FETCH_MESSAGES_ERROR, error: true, payload: e });

const sendMessageRequest = () => ({ type: SEND_MESSAGE_REQUEST });
const sendMessageSuccess = () => ({ type: SEND_MESSAGE_SUCCESS });
const sendMessageError = e => ({ type: SEND_MESSAGE_ERROR, error: true, payload: e });

const sendReviewRequest = () => ({ type: SEND_REVIEW_REQUEST });
const sendReviewSuccess = () => ({ type: SEND_REVIEW_SUCCESS });
const sendReviewError = e => ({ type: SEND_REVIEW_ERROR, error: true, payload: e });

const updateBookingRequest = () => ({ type: UPDATE_BOOKING_REQUEST });
const updateBookingSuccess = () => ({ type: UPDATE_BOOKING_SUCCESS });
const updateBookingError = e => ({ type: UPDATE_BOOKING_ERROR, error: true, payload: e });

const confirmPaymentRequest = () => ({ type: CONFIRM_PAYMENT_REQUEST });

const confirmPaymentSuccess = orderId => ({
  type: CONFIRM_PAYMENT_SUCCESS,
  payload: orderId,
});

const confirmPaymentError = e => ({
  type: CONFIRM_PAYMENT_ERROR,
  error: true,
  payload: e,
});

const createChargeRequest = () => ({
  type: CREATE_CHARGE_REQUEST,
});

const createChargeSuccess = charge => ({
  type: CREATE_CHARGE_SUCCESS,
  payload: charge,
});

const createChargeError = error => ({
  type: CREATE_CHARGE_ERROR,
  payload: error,
});

export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

export const setOmiseRecipientDataRequest = () => ({ type: SET_OMISE_RECIPIENT_DATA_REQUEST });
export const setOmiseRecipientDataSuccess = recipient => ({
  type: SET_OMISE_RECIPIENT_DATA_SUCCESS,
  payload: recipient,
});
export const setOmiseRecipientDataError = e => ({
  type: SET_OMISE_RECIPIENT_DATA_ERROR,
  payload: e,
});

// ================ Selectors ================ //

export const getMessagesProgress = state => {
  const { sendMessageInProgress, sendMessageError } = state.TransactionPage || {};
  return {
    sendMessageInProgress,
    sendMessageError,
  };
};

// ================ Thunks ================ //

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone) => (dispatch, getState, sdk) => {
  const monthId = monthIdString(start, timeZone);

  dispatch(fetchTimeSlotsRequest(monthId));

  // The maximum pagination page size for timeSlots is 500
  const extraParams = {
    perPage: 500,
    page: 1,
  };

  return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }))
    .then(timeSlots => {
      dispatch(fetchTimeSlotsSuccess(monthId, timeSlots));
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(monthId, storableError(e)));
    });
};

// Helper function for loadData call.
const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const { availabilityPlan, publicData } = listing?.attributes || {};
  const tz = availabilityPlan?.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && !!tz) {
    const unitType = publicData?.unitType;
    const timeUnit = unitType === 'hour' ? 'hour' : 'day';
    const nextBoundary = findNextBoundary(new Date(), timeUnit, tz);

    const nextMonth = getStartOf(nextBoundary, 'month', tz, 1, 'months');
    const nextAfterNextMonth = getStartOf(nextMonth, 'month', tz, 1, 'months');

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonth, tz)),
      dispatch(fetchTimeSlots(listing.id, nextMonth, nextAfterNextMonth, tz)),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};

// Helper to fetch correct image variants for different thunk calls
const getImageVariants = listingImageConfig => {
  const { aspectWidth = 1, aspectHeight = 1, variantPrefix = 'scaled-xlarge' } = listingImageConfig;
  const aspectRatio = aspectHeight / aspectWidth;
  return {
    'fields.image': [
      // Profile images
      'variants.square-small',
      'variants.square-small2x',

      // Listing images:
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
  };
};

const listingRelationship = txResponse => {
  return txResponse.data.data.relationships.listing.data;
};

/**
 * Injects a transaction's included provider relationship as the included
 * listing's author relationship.
 * @param {*} txResponse A SDK response from transactions.show().
 * @returns a copy of the txResponse parameter with a listing.author
 * relationship added, if provider exists in the transaction's relationships.
 */
const injectAuthorRelationship = txResponse => {
  const {
    included,
    data: {
      relationships: { provider },
    },
  } = txResponse.data;

  // If provider has not been included, return the response with no changes.
  if (!provider?.data?.id) {
    return txResponse;
  }

  const includedListingIdx = included.findIndex(inc => inc.type === 'listing');

  // We will set the transaction's provider as the listing's author.
  // The full user resource we want to associate with the listing is
  // already available in the response.data.included array, so we only
  // need to add a relationship reference in the included listing resource.
  included[includedListingIdx] = {
    ...included[includedListingIdx],
    relationships: {
      ...included[includedListingIdx].relationships,
      author: {
        data: {
          id: provider?.data?.id,
          type: 'user',
        },
      },
    },
  };

  return {
    ...txResponse,
    data: {
      ...txResponse.data,
      included: [...included],
    },
  };
};

export const fetchTransaction = (id, txRole, config) => (dispatch, getState, sdk) => {
  dispatch(fetchTransactionRequest());
  return sdk.transactions
    .show(
      {
        id,
        include: [
          'customer',
          'customer.profileImage',
          'provider',
          'provider.profileImage',
          'listing',
          'listing.currentStock',
          'listing.images',
          'booking',
          'reviews',
          'reviews.author',
          'reviews.subject',
        ],
        ...getImageVariants(config.layout.listingImage),
      },
      { expand: true }
    )
    .then(response => {
      const listingId = listingRelationship(response).id;
      const entities = updatedEntities({}, response.data);
      const listingRef = { id: listingId, type: 'listing' };
      const transactionRef = { id, type: 'transaction' };
      const denormalised = denormalisedEntities(entities, [listingRef, transactionRef]);
      const listing = denormalised[0];
      const transaction = denormalised[1];
      const processName = resolveLatestProcessName(transaction.attributes.processName);

      try {
        const process = getProcess(processName);
        const isInquiry = process.getState(transaction) === process.states.INQUIRY;

        // if (canFetchTimeslots) {
        fetchMonthlyTimeSlots(dispatch, listing);
        // }
      } catch (error) {
        console.log(`transaction process (${processName}) was not recognized`);
      }

      // API does not allow fetching transaction.listing.author, so we will
      // set the relationship manually based on the transaction's provider.
      return injectAuthorRelationship(response);
    })
    .then(response => {
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };

      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(fetchTransactionSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchTransactionError(storableError(e)));
      throw e;
    });
};

const delay = ms => new Promise(resolve => window.setTimeout(resolve, ms));
const refreshTx = (sdk, txId) => sdk.transactions.show({ id: txId }, { expand: true });
const maybeSendWelcomeGuideMessage = async ({
  currentUser,
  paymentMethod,
  transactionId,
  transitionName,
  transaction,
  provider,
  providerId,
  welcomeGuide,
}) => {
  const shouldSendWelcomeGuide = shouldPersistWelcomeGuideMessage({
    currentUser,
    paymentMethod,
    provider,
    providerId,
    transaction,
    transitionName,
    welcomeGuide,
  });

  // if (!shouldSendWelcomeGuide) {
  //   return null;
  // }
  try {
    return await sendWelcomeGuideMessageApi({
      transactionId,
      transitionName,
    });
  } catch (e) {
    log.error(e, 'welcome-guide-send-failed', {
      transactionId: transactionId?.uuid || transactionId,
      transitionName,
    });
    return null;
  }
};

const refreshTransactionEntity = (sdk, txId, dispatch) => {
  delay(3000)
    .then(() => refreshTx(sdk, txId))
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      const lastTransition = response?.data?.data?.attributes?.lastTransition;
      // We'll make another attempt if mark-received-from-purchased from default-purchase process is still the latest.
      if (lastTransition === 'transition/mark-received-from-purchased') {
        return delay(8000)
          .then(() => refreshTx(sdk, txId))
          .then(response => {
            dispatch(addMarketplaceEntities(response));
          });
      }
    })
    .catch(e => {
      // refresh failed, but we don't act upon it.
      console.log('error', e);
    });
};

export const makeTransition = (
  listing,
  txId,
  transitionName,
  params,
  config,
  transaction,
  newCustomerRecipientId
) => async (dispatch, getState, sdk) => {
  if (transitionInProgress(getState())) {
    throw new Error('Transition already in progress');
  }
  const currentUser = getState().user?.currentUser;
  const { omiseChargeId } = transaction?.attributes?.metadata || {};
  const paymentMethod = getEffectivePaymentMethod(transaction);
  const isPayLaterTx = isPayLaterTransaction(transaction);
  const lastTransition = transaction?.attributes?.lastTransition;
  const { payoutTotal, payinTotal } = transaction?.attributes || {};
  const welcomeGuide = listing && getWelcomeGuide(listing);
  const isReschdule = hasAcceptedReschedule(transaction?.attributes?.transitions);

  const customerRecipientId = getRecipientId(transaction?.customer) || newCustomerRecipientId;
  dispatch(transitionRequest(transitionName));
  const authorId = transaction?.provider?.id?.uuid;

  const shouldUseSnapshotRefund =
    lastTransition === TRANSITIONS.REQUEST_ACCOUNT_INFO_BY_PROVIDER && isPayLaterTx;

  try {
    if (
      transitionName === transitions.ACCEPT &&
      omiseChargeId &&
      paymentMethod === PAYMENT_METHODS.CARD
    ) {
      await captureChargeApi({ chargeId: omiseChargeId, transactionId: txId?.uuid });
    }

    if (
      transitionName === transitions.DECLINE &&
      omiseChargeId &&
      paymentMethod === PAYMENT_METHODS.CARD
    ) {
      await reverseCardChargeApi({ chargeId: omiseChargeId, transactionId: txId?.uuid });
    }

    if (
      transitionName === transitions.CANCEL_BY_CUSTOMER &&
      omiseChargeId &&
      paymentMethod === PAYMENT_METHODS.CARD
    ) {
      const refundObj = calculateCustomerRefund(
        transaction,
        new Date(),
        transitionName,
        isReschdule,
        lastTransition
      );
      const cancelObj = getCancelEmailObject(transaction, refundObj);

      await createCardRefundApi({
        chargeId: omiseChargeId,
        amount: refundObj?.refundAmount,
        refundObj,
        transactionId: txId?.uuid,
        payinTotal,
        payoutTotal,
        isReschdule,
        cancelObj,
      });
    }

    if (
      transitionName === transitions.CANCEL_BY_CUSTOMER &&
      omiseChargeId &&
      customerRecipientId &&
      isPayLaterTx
    ) {
      const refundObj = calculateCustomerRefund(
        transaction,
        new Date(),
        transitionName,
        isReschdule,
        lastTransition
      );
      const cancelObj = getCancelEmailObject(transaction, refundObj);

      await createNonCardRefundApi({
        chargeId: omiseChargeId,
        amount: refundObj?.refundAmount,
        refundObj,
        transactionId: txId?.uuid,
        payinTotal,
        payoutTotal,
        customerRecipientId,
        isReschdule,
        cancelObj,
        authorId,
      });
    }
    if (
      transitionName === transitions.ADD_ACCOUNT_INFO_BY_CUSTOMER &&
      omiseChargeId &&
      customerRecipientId &&
      isPayLaterTx
    ) {
      const refundObj = shouldUseSnapshotRefund
        ? buildRefundObjFromCancelOrMeta(transaction)
        : calculateCustomerRefund(
            transaction,
            new Date(),
            transitionName,
            isReschdule,
            lastTransition
          );
      const cancelObj = getCancelEmailObject(transaction, refundObj);
      await createNonCardRefundApi({
        chargeId: omiseChargeId,
        amount: refundObj?.refundAmount,
        refundObj,
        transactionId: txId?.uuid,
        payinTotal,
        payoutTotal,
        customerRecipientId,
        isReschdule,
        cancelObj,
        authorId,
      });
    }

    if (transitionName === transitions.REQUEST_ACCOUNT_INFO_BY_PROVIDER && isPayLaterTx) {
      const refundObj = calculateProviderRefund(
        transaction,
        new Date(),
        isReschdule,
        transitionName
      );
      const cancelObj = getCancelEmailObject(transaction, refundObj);
      await createNonCardRefundApi({
        chargeId: omiseChargeId,
        amount: refundObj?.refundAmount,
        refundObj,
        transactionId: txId?.uuid,
        payinTotal,
        payoutTotal,
        customerRecipientId,
        isReschdule,
        cancelObj,
        transitionName,
        authorId,
      });
      dispatch(updateProfile({ publicData: { flagged: `${refundObj?.flag}-${txId?.uuid}` } }));
    }
    if (
      (transitionName === transitions.CANCEL_BY_PROVIDER ||
        transitionName === TRANSITIONS.INITIATE_REFUND) &&
      omiseChargeId &&
      customerRecipientId &&
      isPayLaterTx
    ) {
      const refundObj = calculateProviderRefund(transaction, new Date(), isReschdule);
      const cancelObj = getCancelEmailObject(transaction, refundObj);
      await createNonCardRefundApi({
        chargeId: omiseChargeId,
        amount: refundObj?.refundAmount,
        refundObj,
        transactionId: txId?.uuid,
        payinTotal,
        payoutTotal,
        customerRecipientId,
        isReschdule,
        cancelObj,
        isProvider: true,
        authorId,
      });
      dispatch(updateProfile({ publicData: { flagged: `${refundObj?.flag}-${txId?.uuid}` } }));
    }

    if (
      transitionName === transitions.CANCEL_BY_PROVIDER &&
      omiseChargeId &&
      paymentMethod === PAYMENT_METHODS.CARD
    ) {
      const refundObj = calculateProviderRefund(transaction, new Date(), isReschdule);
      const cancelObj = getCancelEmailObject(transaction, refundObj);
      await createCardRefundApi({
        chargeId: omiseChargeId,
        amount: refundObj?.refundAmount,
        refundObj,
        transactionId: txId?.uuid,
        payinTotal,
        payoutTotal,
        isReschdule,
        cancelObj,
      });
      dispatch(updateProfile({ publicData: { flagged: `${refundObj?.flag}-${txId?.uuid}` } }));
    }

    const response = await sdk.transactions.transition(
      { id: txId, transition: transitionName, params },
      { expand: true }
    );

    if (transitionName === transitions.ACCEPT_RESCHEDULE_BOOKING) {
      await captureChargeApi({ chargeId: omiseChargeId, transactionId: txId?.uuid });
    }

    if (
      (transitionName === transitions.ACCEPT &&
        omiseChargeId &&
        paymentMethod === PAYMENT_METHODS.CARD) ||
      transitionName === transitions.ACCEPT_RESCHEDULE_BOOKING
    ) {
      generatePaymentReceiptApi({ transactionId: txId?.uuid })
        .then(res => {
          console.log('confirmed booking receipt response', res);
        })
        .catch(e => {
          log.error(e, 'confirmed-booking-receipt-generation-failed', {
            transactionId: txId?.uuid,
            transitionName,
          });
        });
    }

    dispatch(addMarketplaceEntities(response));
    dispatch(transitionSuccess());
    dispatch(fetchCurrentUserNotifications());
    dispatch(fetchTransaction(txId, 'customer', config));

    await maybeSendWelcomeGuideMessage({
      currentUser,
      paymentMethod,
      transactionId: txId,
      transitionName,
      transaction: response?.data?.data || transaction,
      welcomeGuide,
    });

    // Could trigger delayed refresh for auto transitions
    refreshTransactionEntity(sdk, txId, dispatch);

    return response;
  } catch (e) {
    dispatch(transitionError(storableError(e)));
    log.error(e, `${transitionName}-failed`, {
      txId,
      transition: transitionName,
    });
    throw e;
  }
};

export const confirmPayment = (
  transactionId,
  transitionName,
  transitionParams = {},
  config
) => async (dispatch, getState, sdk) => {
  dispatch(confirmPaymentRequest());
  const currentUser = getState().user?.currentUser;

  const bodyParams = {
    id: transactionId,
    transition: transitionName,
    params: transitionParams,
  };

  // ✅ include listing so we can read welcomeGuide from it
  const queryParams = {
    include: ['booking', 'provider', 'listing'],
    expand: true,
  };

  try {
    const response = await sdk.transactions.transition(bodyParams, queryParams);
    const order = response.data.data;

    const paymentMethod = getEffectivePaymentMethod(order);

    // ✅ get listing entity from included (expanded)
    const included = response?.data?.included || [];
    const listingId = order?.relationships?.listing?.data?.id?.uuid;
    const listing =
      included.find(e => e?.type === 'listing' && e?.id?.uuid === listingId) ||
      included.find(e => e?.type === 'listing') ||
      null;

    const welcomeGuide = listing && getWelcomeGuide(listing);

    const providerId = order?.relationships?.provider?.data?.id?.uuid;
    await maybeSendWelcomeGuideMessage({
      currentUser,
      paymentMethod,
      transactionId: order.id,
      transitionName,
      transaction: order,
      providerId,
      welcomeGuide,
    });

    dispatch(confirmPaymentSuccess(order.id));
    await completeCustomOfferPaymentIfNeeded({ order, transactionId, transitionName });
    const shouldGenerateConfirmedReceipt =
      isPayLaterTransaction(order) || !!order?.attributes?.protectedData?.customOffer?.id;
    if (shouldGenerateConfirmedReceipt) {
      generatePaymentReceiptApi({ transactionId: order?.id?.uuid })
        .then(res => {
          console.log('confirmed payment receipt response', res);
          dispatch(fetchTransaction(transactionId, 'customer', config));
        })
        .catch(e => {
          log.error(e, 'confirmed-payment-receipt-generation-failed', {
            transactionId: order?.id?.uuid,
            transitionName,
          });
        });
    }
    dispatch(fetchMessages(order.id, 1, config)), dispatch(addMarketplaceEntities(response));
    dispatch(transitionSuccess());
    dispatch(fetchCurrentUserNotifications());
    dispatch(fetchTransaction(transactionId, 'customer', config));
    clearData(STORAGE_KEY);

    return order;
  } catch (e) {
    dispatch(confirmPaymentError(storableError(e)));

    const transactionIdMaybe = transactionId ? { transactionId: transactionId.uuid } : {};
    log.error(e, 'initiate-order-failed', { ...transactionIdMaybe });

    throw e;
  }
};

export const sendMsgAfterConfirmPayment = (transactionId, config) => async (
  dispatch,
  getState,
  sdk
) => {
  const currentUser = getState().user?.currentUser;
  const bodyParams = {
    id: transactionId,
    include: ['booking', 'provider', 'listing'],
  };
  try {
    const response = await sdk.transactions.show(bodyParams);
    const order = response.data.data;

    // ✅ get listing entity from included (expanded)
    const included = response?.data?.included || [];
    const listingId = order?.relationships?.listing?.data?.id?.uuid;
    const listing =
      included.find(e => e?.type === 'listing' && e?.id?.uuid === listingId) ||
      included.find(e => e?.type === 'listing') ||
      null;

    const welcomeGuide = listing && getWelcomeGuide(listing);
    const providerId = order?.relationships?.provider?.data?.id?.uuid;
    const paymentMethod = getEffectivePaymentMethod(order);
    const welcomeGuideTransition = isPayLaterTransaction(order)
      ? order?.attributes?.lastTransition || transitions.CONFIRM_PAY_LATER_PAYMENT
      : transitions.CONFIRM_PAYMENT;
    await maybeSendWelcomeGuideMessage({
      currentUser,
      paymentMethod,
      transactionId: order.id,
      transitionName: welcomeGuideTransition,
      transaction: order,
      providerId,
      welcomeGuide,
    });

    dispatch(fetchMessages(order.id, 1, config)), dispatch(fetchCurrentUserNotifications());
    dispatch(fetchTransaction(transactionId, 'customer', config));
    clearData(STORAGE_KEY);

    return order;
  } catch (e) {
    dispatch(confirmPaymentError(storableError(e)));

    const transactionIdMaybe = transactionId ? { transactionId: transactionId.uuid } : {};
    log.error(e, 'initiate-order-failed', { ...transactionIdMaybe });

    throw e;
  }
};

const fetchMessages = (txId, page, config) => (dispatch, getState, sdk) => {
  const paging = { page, perPage: MESSAGES_PAGE_SIZE };
  dispatch(fetchMessagesRequest());

  return sdk.messages
    .query({
      transaction_id: txId,
      include: ['sender', 'sender.profileImage'],
      ...getImageVariants(config.layout.listingImage),
      ...paging,
    })
    .then(response => {
      const messages = denormalisedResponseEntities(response);
      const { totalItems, totalPages, page: fetchedPage } = response.data.meta;
      const pagination = { totalItems, totalPages, page: fetchedPage };
      const totalMessages = getState().TransactionPage.totalMessages;

      // Original fetchMessages call succeeded
      dispatch(fetchMessagesSuccess(messages, pagination));

      // Check if totalItems has changed between fetched pagination pages
      // if totalItems has changed, fetch refundAmount page again to include new incoming messages.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.
      if (totalItems > totalMessages && page > 1) {
        dispatch(fetchMessages(txId, 1, config))
          .then(() => {
            // Original fetch was enough as a response for user action,
            // this just includes new incoming messages
          })
          .catch(() => {
            // Background update, no need to to do anything atm.
          });
      }
    })
    .catch(e => {
      dispatch(fetchMessagesError(storableError(e)));
      throw e;
    });
};

export const fetchMoreMessages = (txId, config) => (dispatch, getState, sdk) => {
  const state = getState();
  const { oldestMessagePageFetched, totalMessagePages } = state.TransactionPage;
  const hasMoreOldMessages = totalMessagePages > oldestMessagePageFetched;

  // In case there're no more old pages left we default to fetching the current cursor position
  const nextPage = hasMoreOldMessages ? oldestMessagePageFetched + 1 : oldestMessagePageFetched;

  return dispatch(fetchMessages(txId, nextPage, config));
};

const idString = id => (id?.uuid ? id.uuid : String(id || ''));

const transactionRefForMessageSend = (txId, state) => {
  const transactionRef = state.TransactionPage?.transactionRef;
  const txIdString = idString(txId);
  if (transactionRef && (!txIdString || idString(transactionRef.id) === txIdString)) {
    return state.TransactionPage.transactionRef;
  }

  if (!txId) {
    return null;
  }

  return {
    id: txId.uuid ? txId : new UUID(txId),
    type: 'transaction',
  };
};

const getTransactionForMessageSend = (txId, state) => {
  const txRef = transactionRefForMessageSend(txId, state);
  const transactions = getMarketplaceEntities(state, txRef ? [txRef] : []);
  return transactions.length > 0 ? transactions[0] : null;
};

export const sendMessage = (txId, message, config) => (dispatch, getState, sdk) => {
  dispatch(sendMessageRequest());
  const state = getState();
  const transaction = getTransactionForMessageSend(txId, state);
  const currentUser = state.user?.currentUser;

  if (shouldBlockPreBookingMessage({ message, transaction, currentUser })) {
    const error = createPreBookingContactBlockError();
    dispatch(sendMessageError(storableError(error)));
    return Promise.reject(error);
  }

  return sendTransactionMessageApi({ transactionId: txId, content: message })
    .then(response => {
      const messageId = response?.data?.messageId;

      // We fetch the first page again to add sent message to the page data
      // and update possible incoming messages too.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.
      return dispatch(fetchMessages(txId, 1, config))
        .then(() => {
          dispatch(sendMessageSuccess());
          return messageId;
        })
        .catch(() => dispatch(sendMessageSuccess()));
    })
    .catch(e => {
      dispatch(sendMessageError(storableError(e)));
      // Rethrow so the page can track whether the sending failed, and
      // keep the message in the form for a retry.
      throw e;
    });
};

export const sendReview = (tx, transitionOptionsInfo, params, config) => (dispatch, getState) => {
  const { reviewAsFirst, reviewAsSecond, hasOtherPartyReviewedFirst } = transitionOptionsInfo;
  dispatch(sendReviewRequest());

  const transition = hasOtherPartyReviewedFirst ? reviewAsSecond : reviewAsFirst;
  const fallbackTransition = hasOtherPartyReviewedFirst ? reviewAsFirst : reviewAsSecond;

  return submitReviewApi({
    transactionId: tx?.id,
    transition,
    fallbackTransition,
    params,
  })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(sendReviewSuccess());
      return response;
    })
    .catch(e => {
      dispatch(sendReviewError(storableError(e)));
      throw e;
    });
};

const isNonEmpty = value => {
  return typeof value === 'object' || Array.isArray(value) ? !isEmpty(value) : !!value;
};

const ignoreOptionalLoadError = promise => promise.catch(() => null);

export const fetchNextTransitions = id => (dispatch, getState, sdk) => {
  dispatch(fetchTransitionsRequest());

  return sdk.processTransitions
    .query({ transactionId: id })
    .then(res => {
      dispatch(fetchTransitionsSuccess(res.data.data));
    })
    .catch(e => {
      dispatch(fetchTransitionsError(storableError(e)));
    });
};

export const fetchTransactionLineItems = ({ orderData, listingId, isOwnListing }) => dispatch => {
  dispatch(fetchLineItemsRequest());
  transactionLineItems({ orderData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        orderData,
      });
    });
};

export const updateBooking = (transaction, transitionName, params, config) => async (
  dispatch,
  getState,
  sdk
) => {
  const txId = transaction?.id;

  const { rescheduleStart, rescheduleEnd } = params;

  const rescheduleBookingParams = {
    rescheduleStartUnix: rescheduleStart,
    rescheduleEndUnix: rescheduleEnd,
  };

  try {
    dispatch(updateBookingRequest());
    const response = await initiaterescheduleBookingApi({
      transaction,
      rescheduleBookingParams,
      transitionName,
    });

    dispatch(fetchTransaction(txId, 'customer', config));

    dispatch(updateBookingSuccess());
  } catch (e) {
    dispatch(updateBookingError(storableError(e)));
  }
};

export const createNonCardCharge = params => async (dispatch, getState) => {
  const {
    amount,
    currency,
    sourceId,
    transactionId,
    paymentMethod,
    sourceType, // 👈 not sourceId anymore
    returnUri,
    authorId,
    customOfferId,
  } = params || {};
  dispatch(createChargeRequest());

  try {
    // Create charge
    const charge = await createNonCardChargeApi({
      amount,
      currency,
      sourceId,
      transactionId,
      returnUri,
      paymentMethod,
      authorId,
      sourceType,
      customOfferId,
    });

    dispatch(createChargeSuccess(charge));
    return charge;
  } catch (error) {
    dispatch(createChargeError(error));
    throw error;
  }
};

export const retrieveOmiseRecipient = () => async (dispatch, getState) => {
  const state = getState();
  const recipientId = selectRecipientId(state);
  if (!recipientId) return null;

  dispatch(setOmiseRecipientDataRequest());
  try {
    const subMerchantId = getSubMerchantIdFromUser(state.user.currentUser);
    const response = await retrieveRecipientApi({ recipientId, subMerchantId });
    if (response?.recipientNotFound) {
      dispatch(setOmiseRecipientDataSuccess(null));
      return null;
    }

    const recipient = response?.recipient || null;
    dispatch(setOmiseRecipientDataSuccess(recipient));
    return recipient;
  } catch (error) {
    dispatch(setOmiseRecipientDataError(error));
    return null;
  }
};

// loadData is a collection of async calls that need to be made
// before page has all the info it needs to render itself
export const loadData = (params, search, config) => async (dispatch, getState) => {
  const txId = new UUID(params.id);
  const state = getState().TransactionPage;
  const txRef = state.transactionRef;
  const txRole = params.transactionRole;

  const initialValues = txRef ? {} : pickBy(state, isNonEmpty);
  dispatch(setInitialValues(initialValues));

  await dispatch(fetchTransaction(txId, txRole, config));

  await Promise.all([
    ignoreOptionalLoadError(dispatch(fetchMessages(txId, 1, config))),
    ignoreOptionalLoadError(dispatch(fetchNextTransitions(txId))),
  ]);

  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };
  await dispatch(fetchCurrentUser(fetchCurrentUserOptions)).catch(() => null);

  const omiseRecipientId = selectRecipientId(getState());
  if (omiseRecipientId) {
    await dispatch(retrieveOmiseRecipient()).catch(() => null);
  }

  return null;
};
